import * as React from "react";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import { resourcesHelper } from "@falcon/services";

interface IProps {
    scrollElementId: string;
}

interface IState {
    isOpen: boolean;
}

export class RenewalPaymentDayChangeModal extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            isOpen: true
        };
        this.close = this.close.bind(this);
    }

    public render() {
        return (
            <Modal className={"success-modal"} isOpen={this.state.isOpen}>
                <ModalHeader close={<button className="btn-close" onClick={this.close}/>}>
                    <div className="d-flex success-icon-container">
                        <img
                            className="success-icon d-block"
                            src={`/${resourcesHelper.THEME}/img/Flow-info-selected.svg`}
                            aria-label="Info picture"
                            height={50}
                        />
                        <span
                            id="success-modal-title"
                            className="success-title"
                        >
                            <p>Heads up!</p>
                        </span>
                    </div>
                </ModalHeader>
                <ModalBody className="pt-0">
                    <div className={"renewal-change-payment-day"}>
                        <p>
                            Your change will take effect in a future month and
                            won’t apply to your next payment. Please{" "}
                            <button className="btn-text cursor-pointer"
                                    onClick={()=> this.scrollTo(this.props.scrollElementId)}>
                                <span className="text-decoration-underline">check your schedule</span>
                            </button>{" "}
                            as this could result in two payments close together.
                        </p>
                    </div>
                </ModalBody>
                <div className="empty-column" />
                <ModalFooter>
                    <button
                        type="button"
                        className="btn btn-primary btn-modal m-0"
                        onClick={this.close}
                    >
                        Ok, I understand
                    </button>
                </ModalFooter>
            </Modal>
        );
    }

    private close(): void {
        this.setState({
            isOpen: false
        });

        window.sessionStorage.removeItem("showRenewalChangePaymentDayPopup");
    }

    private readonly scrollTo = (elementId: string): void => {
        const element: Element = document.getElementById(elementId)!;
        this.close();
        element.scrollIntoView();
        window.scrollBy(0, -100);
    };
}
